import angular from 'angular';

angular.module('myConsultApp').factory('ResourceInterceptor', (Session, ENV) => ({
  request: (config) => {
    const requestConfig = { ...config };
    const { url } = requestConfig;

    const {
      sfmcStoriesSearchURL,
      sfmcAssetsBaseUrl,
      sfmcStoriesSearchApiKey,
      sfmcAssetsApiKey,
    } = ENV;

    if ((url || '').includes(sfmcStoriesSearchURL)) {
      requestConfig.headers['api-key'] = `${sfmcStoriesSearchApiKey}`;
    } else if ((url || '').includes(sfmcAssetsBaseUrl)) {
      requestConfig.headers.Authorization = `Api-Key ${sfmcAssetsApiKey}`;
    } else if (Session.accessToken) {
      requestConfig.headers.Authorization = `Bearer ${Session.accessToken}`;
    }

    return requestConfig;
  },
}));
